import { FadeUp } from "./Reveal";
import { PROCESS, INDUSTRIES } from "../../lib/site";

export default function ProcessIndustries() {
  return (
    <section id="process" className="relative py-24 lg:py-32 bg-[#050B14] border-y border-white/10" data-testid="process-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        {/* Process */}
        <FadeUp className="mb-16 max-w-2xl">
          <span className="font-body text-xs tracking-[0.35em] text-[#00D166]">OUR METHOD</span>
          <h2 className="mt-4 font-display text-4xl md:text-6xl font-bold tracking-tight text-white">
            The search, <span className="font-serifed italic font-normal text-white/60">refined.</span>
          </h2>
        </FadeUp>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 mb-28">
          {PROCESS.map((p, i) => (
            <FadeUp key={p.no} delay={i * 0.08}>
              <div className="bg-[#050B14] p-8 lg:p-10 h-full hover:bg-[#0F172A] transition-colors duration-400">
                <span className="font-serifed italic text-5xl text-white/15">{p.no}</span>
                <h3 className="mt-6 font-display text-xl font-bold text-white">{p.title}</h3>
                <p className="mt-3 font-body text-sm text-white/55 leading-relaxed">{p.desc}</p>
              </div>
            </FadeUp>
          ))}
        </div>

        {/* Industries */}
        <FadeUp className="mb-12 max-w-2xl">
          <span className="font-body text-xs tracking-[0.35em] text-[#00D166]">SECTORS</span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold tracking-tight text-white">
            Industries we serve
          </h2>
        </FadeUp>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {INDUSTRIES.map((ind, i) => (
            <div
              key={ind}
              data-testid={`industry-${i}`}
              className="group bg-[#050B14] p-8 lg:p-10 hover:bg-[#00D166] transition-colors duration-400 cursor-default"
            >
              <span className="font-body text-xs text-white/30 group-hover:text-[#030712]/60">{String(i + 1).padStart(2, "0")}</span>
              <p className="mt-4 font-display text-lg lg:text-xl font-bold text-white group-hover:text-[#030712] transition-colors">{ind}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
